import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowSending() {
    return (
        <React.Fragment>
            <p>
                When sending content in a distribution workflow, transfers driven by Jet can send content from an
                internal system to Media Shuttle users by transferring data to an SDCX server that also functions as
                portal storage. This allows content to transfer from an internal asset management system to recipients
                in distributed locations. Jet can also be used with a Share portal to distribute files that are part of
                a larger workflow that provides access to a common storage location.
            </p>
            <p>A Jet to Media Shuttle distribution workflow includes:</p>
            <ul>
                <li>
                    A Jet job that has its source endpoint on the company's internal network and its destination
                    endpoint in the perimeter network
                </li>
                <li>
                    A Send or Share portal with a storage path that points to the same location as the destination
                    endpoint for the Jet job
                </li>
            </ul>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowSending.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowSending);
